import React, { FC } from 'react';
import { View } from 'react-native';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import EventStatusSubStatusExecMode, { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';

export interface StatusCellProps extends Pick<UseTableColumnsParams, 'C' | 'font' | 'scale'>, Pick<EventStatusSubStatusExecModeProps, 'event'> {
  includeExtraInfoBasedOnNCFileStatus?: boolean;
}

const StatusCell: FC<StatusCellProps> = ({ event, C, scale = initialScale, font = initialFont, includeExtraInfoBasedOnNCFileStatus = false }) => {
  return (
    <View>
      <EventStatusSubStatusExecMode
        C={C}
        event={event}
        font={font}
        scale={scale}
        includeExtraInfoBasedOnNCFileStatus={includeExtraInfoBasedOnNCFileStatus}
      />
    </View>
  );
};

export default React.memo(StatusCell, (prev, next) => {
  return prev.event.sequenceNumber === next.event.sequenceNumber && prev.event.status === next.event.status && prev.C.scheme === next.C.scheme;
});
